import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { LS } from 'src/app/helpers/localStorage.enum';
// import { AnnotationService } from 'src/app/services/annotation/annotation.service';
import { DataService } from 'src/app/services/data/data.service';
import {
  ILocation,
  LocationService,
} from 'src/app/services/location/location.service';
import { MapLayerService } from 'src/app/services/map-layer/map-layer.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { SplitViewService } from 'src/app/services/split-view/split-view.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';
import { SearchListComponent } from './search-list/search-list.component';
import { SeverityData } from './widget-list/widget-one/widget-one.component';

@Component({
  selector: 'app-card-small',
  templateUrl: './card-small.component.html',
  styleUrls: ['./card-small.component.sass'],
})
export class CardSmallComponent implements OnInit, OnDestroy {
  sticky: string[] = [];
  // dataServiceSub: Subscription;
  // annotationServiceSub: Subscription;
  severityData: SeverityData[] = [
    { severity_level: 'critical', value: 0, color: '' },
    { severity_level: 'medium', value: 0, color: '' },
    { severity_level: 'safe', value: 0, color: '' },
  ];
  currLocSub: Subscription;
  locIds: string[];

  currentUser: any;
  permissions: any;
  isTimeline: boolean;

  map_layers = [];
  unsubber: Subject<boolean> = new Subject<boolean>();

  @ViewChild(SearchListComponent) searchList: SearchListComponent;
  currLoc: ILocation;

  ctqrs_widget_data;
  notifications = [];

  constructor(
    private dataService: DataService,
    private locationService: LocationService,
    // private annotationService: AnnotationService,
    private mapLayerService: MapLayerService,
    private splitViewService: SplitViewService,
    private router: Router,
    private locationStore: LocationStoreService,
    private notificationService: NotificationService
  ) {
    this.dataService.localStorageSub$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        if (res.key === LS.currentUser) {
          this.currentUser = JSON.parse(res.data);
          this.permissions = this.currentUser.permissions;
        } else {
          this.currentUser = JSON.parse(localStorage.getItem(LS.currentUser));
          this.permissions = this.currentUser.permissions;
        }
      });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (event.urlAfterRedirects === '/projects') {
            this.getDefectCount();
          }
        }
      });

    this.locationStore.currLocation$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((loc) => {
        this.currLoc = loc;
        if (loc.id && loc.descendants) {
          const locIds = [...loc.descendants, loc.id];
          this.locIds = locIds;
          this.getDefectCount(locIds, loc.id);
          this.getCtqrsWidgetData();
        }
        this.isTimeline = false;
      });
    this.dataService.allDefectCounts$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((allDefectCounts) => {
        if (!allDefectCounts[0]) {
          return;
        }
        this.severityData = allDefectCounts as any[];
      });
  }

  ngOnInit(): void {
    this.dataService.sticky$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((i) => (this.sticky = [...i]));

    this.locationStore.currLocation$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((loc) => {
        this.currLoc = loc;
        if (loc.id) {
          this.mapLayerService.getMapLayerTimeline(loc.id);
          this.getCtqrsWidgetData();
        }
      });

    this.mapLayerService.timelineMaplayer$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        if (res) this.map_layers = res;
      });

    this.splitViewService.onEvent$
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((res) => {
        if (res.toggleTimeLine === undefined) return;
        this.isTimeline = !this.isTimeline;
      });

    this.notificationService
      .findAll()
      .pipe(takeUntil(this.unsubber.asObservable()))
      .subscribe((noti) => this.notifications.push(noti));
  }

  getDefectCount = async (locations?: string[], locationId?: string) => {
    let allLocations = this.locationStore.allLocations;
    if (!allLocations['parents']) {
      const usersLocations = await this.locationService
        .getSummaries()
        .toPromise();
      this.locationStore.allLocations = usersLocations.allLocations;
      this.dataService.allDefectCounts = usersLocations.defectSeverities;
      allLocations = this.locationStore.allLocations;
    }

    if (!locationId) {
      this.locationStore.setLocations = allLocations['parents'];
      this.dataService.allDefectCounts$.next(this.dataService.allDefectCounts);
    }
  };

  toggleStick(type) {
    if (this.sticky.includes(type))
      this.sticky = this.sticky.filter((i) => i !== type);
    else this.sticky = [type]; //enable this for one sticky
    // else this.sticky.push(type) //enable this for multiple sticky

    this.dataService.sticky$.next(this.sticky);
  }

  ngOnDestroy() {
    // this.dataServiceSub.unsubscribe()
    this.unsubber.next();
    this.unsubber.unsubscribe();
  }

  toggleTimeline(data: boolean) {
    // toggle timeline if add button is clicked numerously
    if (data && this.isTimeline) this.isTimeline = !this.isTimeline;
    // else
    else this.isTimeline = data;
  }

  attachMapLayer(layer) {
    const skipZoom = this.splitViewService.selectedOrtho?.id !== layer.id;
    // this.splitViewService.onEvent$.next({ onClickAdd: true })
    if (this.splitViewService.addingMap) {
      this.splitViewService.onEvent$.next({
        onClickAdd: true,
        skipZoom: skipZoom,
        orthoLayer: layer,
      });
    } else {
      this.splitViewService.onEvent$.next({
        onAddOrtho: true,
        skipZoom: skipZoom,
        orthoLayer: layer,
      });
    }
    this.splitViewService.addingMap = false;
    // this.isTimeline = null;
  }

  onIconClicked(type: string) {
    switch (type) {
      case 'project': {
        if (!this.searchList) break;

        this.searchList.toggleIsSearch(true);
        break;
      }
    }
  }

  getCtqrsWidgetData() {
    const { cost, time, resource, quality, safety } =
      this.currLoc.ctqrs_widget_data;
    const totCost = cost.actual_cumulative_all + cost.budget_cumulative_all;
    const totResourse =
      resource.actual_cumulative_all + resource.budget_cumulative_all;
    const planned = time.latest_planned
      ? Math.round(time.latest_planned['value'][1])
      : 100;
    const actual = time.latest_actual
      ? Math.round(time.latest_actual['value'][1])
      : 0;

    this.ctqrs_widget_data = {
      cost: isNaN((cost.actual_cumulative_all / totCost) * 100)
        ? 0
        : ((cost.actual_cumulative_all / totCost) * 100).toFixed(0),
      time: {
        planned,
        actual,
        delta: Math.round(actual - planned),
      },
      resource: isNaN((resource.actual_cumulative_all / totResourse) * 100)
        ? 0
        : ((resource.actual_cumulative_all / totResourse) * 100).toFixed(0),
      quality: quality,
      safety: safety,
    };
  }
}
